<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="z-title z-title--small">
          Cobrança via cartão de crédito
        </div>
        <p class="z-text">
          Cobraremos essa mensalidade automaticamente no dia <strong>{{ dueDate }}</strong>.
        </p>

        <div class="z-card price-card">
          <div class="price-card__value">
            {{ currentBill.bill_value | formatCurrency }}
          </div>
          <div class="price-card__label">
            Mensalidade de {{ currentBill.month_name }}
          </div>
        </div>

        <div class="z-caption spacer-bottom-m">
          Cartão de cobrança
        </div>

        <div class="z-card z-card--small">
          <card-details :card="currentBilling.student_card" />

          <router-link
            tag="button"
            :to="{ name: 'cpm-credit-card-selection'}"
            class="z-button z-button--primary z-button--block"
            @click.native="changedCreditCard()"
          >
            Trocar cartão de crédito
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.price-card {
  margin-bottom: var(--space-extra-large);
  margin-top: var(--space-extra-large);
  text-align: center;
}

.price-card__value {
  font-size: rem(33);
  font-weight: bold;
  line-height: rem(40);
}

.price-card__label {
  color: var(--color-neutral-dark-gray);
  font-size: rem(13);
  font-weight: var(--font-weight-bold);
  line-height: rem(20);
  text-transform: uppercase;
}

.payment-code {
  color: var(--color-neutral-black);
  font-size: rem(16);
  line-height: rem(24);
  margin-bottom: var(--space-extra-large);
}
</style>

<script>
import { mapState } from 'vuex';
import Breadcrumb from 'components/breadcrumb';
import CardDetails from 'components/card-details';
import DateUtils from 'utils/date-utils';

export default {
  components: {
    Breadcrumb,
    CardDetails,
  },
  computed: {
    ...mapState([
      'currentBill',
      'currentBilling',
    ]),
    dueDate() {
      return DateUtils.getFormattedDate(this.currentBill.due_date);
    },
  },
  methods: {
    changedCreditCard() {
      this.$tracker.logEvent('[credit card payment] Clicked "Trocar cartão de crédito"');
    },
  },
  mounted() {
    this.$tracker.logEvent('Viewed Credit Card Payment Details Page', { billId: this.currentBill.id });
  },
};
</script>
